import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { sharedStyles } from 'Views/Pages/Pdf/styles';
import PdfBreak from 'Views/Pages/Pdf/Components/PDFBreak';

interface EndOfDocumentProps {
	customDocumentName?: string
}

const styles = StyleSheet.create({
	endOfDocument: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	endOfDocumentText: {
		flexBasis: '35%',
		textAlign: 'center',
		fontSize: 8,
	},
	dashLine: {
		flexGrow: 1,
		width: '100%',
		borderBottom: '1px solid #E3E3E3',
		borderStyle: 'dashed',
	},
	disclaimerText: {
		textAlign: 'center',
		fontStyle: 'italic',
		marginTop: 12,
	},
});

const EndOfDocument = (props: EndOfDocumentProps) => {
	const { customDocumentName } = props;

	return (
		<View>
			<Text style={styles.disclaimerText}>
				This report is not an official record and is for information purposes only.
				Please contact the University if you have questions about your academic situation and
				meeting the rules and requirements of your qualification.
			</Text>
			<PdfBreak />
			<View style={[sharedStyles.darkGrey, styles.endOfDocument]}>
				<View style={styles.dashLine} />
				<Text style={styles.endOfDocumentText}>End of {customDocumentName || 'Document'}</Text>
				<View style={styles.dashLine} />
			</View>
		</View>
	);
};

export default EndOfDocument;
